import React from 'react';

import { GlobalPageTracker } from './global-page-tracker';
import { tracker } from '../../core/defaults';

export const GlobalTracker: React.FC = () => {
  React.useEffect(() => {
    tracker.enable();
  }, []);

  return <GlobalPageTracker />;
};
